import { IContextData } from '../types';

export function relativePath(from: string[], to: string[]): string[] {
  const length = Math.min(from.length, to.length);
  let samePartsLength = length;
  for (let i = 0; i < length; i++) {
    if (from[i] !== to[i]) {
      samePartsLength = i;
      break;
    }
  }
  if (samePartsLength === 0) {
    return to;
  }
  let outputParts = [];
  for (let i = samePartsLength; i < from.length; i++) {
    outputParts.push('..');
  }
  outputParts = [...outputParts, ...to.slice(samePartsLength)];
  if (outputParts[0] !== '..') {
    outputParts.unshift('.');
  }
  return outputParts;
}

export function getSlotRelativePath(options: {
  contextData: IContextData;
  modulePaths?: string[];
  from?: string;
  to: string;
  moduleName?: string; // 新增参数
}) {
  const { contextData, from, to, modulePaths = [], moduleName } = options;
  const { extraContextData } = contextData || {};
  const isSingleComponent = extraContextData?.projectRemark?.isSingleComponent;
  const template = extraContextData?.template;
  let toPath = to ? template.slots[to].path : [];
  if (to) {
    toPath = [...toPath, template.slots[to].fileName!];
  }

  let fromPath = from ? [...template.slots[from].path, ...modulePaths] : [...modulePaths];
  // if not single component and from is components or pages,
  // add pageName to path unless it's an index page (moduleName is 'index')
  if (!isSingleComponent && from && ['components', 'pages'].indexOf(from) > -1) {
    // Check if this is an index page by checking moduleName
    const isIndexPage = moduleName && moduleName.toLowerCase() === 'index';
    if (!isIndexPage) {
      fromPath = [...fromPath, 'pageName'];
    }
  }
  return relativePath(fromPath, toPath).join('/');
}
